var map = {
	"./404.svg": "a14a",
	"./all.svg": "6d66",
	"./attr.svg": "5628",
	"./brands.svg": "20e2",
	"./bug.svg": "1779",
	"./cancelled.svg": "297d",
	"./card1.svg": "867f",
	"./cards.svg": "846b",
	"./category.svg": "f428",
	"./chart.svg": "c829",
	"./clientuser.svg": "6481",
	"./clipboard.svg": "bc35",
	"./completed.svg": "2e64",
	"./component.svg": "56d6",
	"./contanct_message.svg": "285e",
	"./customer_list.svg": "c093",
	"./customer_setting.svg": "9061",
	"./cycle.svg": "e02e",
	"./dashboard copy.svg": "fa46",
	"./dashboard.svg": "f782",
	"./delivery.svg": "2ca9",
	"./documentation.svg": "90fb",
	"./drag.svg": "9bbf",
	"./duigou.svg": "d979",
	"./edit.svg": "aa46",
	"./education.svg": "ad1c",
	"./email.svg": "cbb7",
	"./example copy.svg": "67c6",
	"./example.svg": "30c3",
	"./excel.svg": "6599",
	"./exit-fullscreen.svg": "dbc7",
	"./eye copy.svg": "83d9",
	"./eye-open copy.svg": "fd57",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./form copy.svg": "b69e",
	"./form.svg": "eb1b",
	"./fullscreen.svg": "9921",
	"./goods.svg": "7421",
	"./guide.svg": "6683",
	"./hot_word.svg": "ddb6",
	"./icon.svg": "9d91",
	"./images.svg": "b0cb",
	"./integral.svg": "6361",
	"./integral_history.svg": "a46a",
	"./international.svg": "17df",
	"./language.svg": "2580",
	"./link copy.svg": "7839",
	"./link.svg": "18f0",
	"./list.svg": "3289",
	"./lock.svg": "ab00",
	"./marker.svg": "edcd",
	"./message.svg": "47ff",
	"./money.svg": "3046",
	"./nested copy.svg": "50b3",
	"./nested.svg": "dcf8",
	"./new_product.svg": "85d8",
	"./notice.svg": "fc99",
	"./opencard.svg": "afe6",
	"./order-return-reason.svg": "7355",
	"./order-return.svg": "480b",
	"./order-setting.svg": "e4b6",
	"./order.svg": "11ff",
	"./password copy.svg": "92bf",
	"./password.svg": "2a3d",
	"./pdf.svg": "f9a1",
	"./people.svg": "d056",
	"./peoples.svg": "2f11",
	"./person_message.svg": "df50",
	"./product-add.svg": "cbc9",
	"./product-list.svg": "e2f5",
	"./qq.svg": "1430",
	"./qyweixin.svg": "9207",
	"./recent_cost.svg": "9499",
	"./recent_cost1.svg": "e36f",
	"./recent_cost2.svg": "b6ab",
	"./recommend.svg": "c30a",
	"./refund.svg": "213d",
	"./report.svg": "9e5c",
	"./search.svg": "8e8d",
	"./shipped.svg": "43fc1",
	"./shopping.svg": "12a5",
	"./size.svg": "8644",
	"./skill.svg": "096e",
	"./sku.svg": "566a",
	"./sms copy.svg": "d14d",
	"./sms-ad.svg": "847c",
	"./sms-coupon.svg": "befc",
	"./sms-flash.svg": "e267",
	"./sms-hot.svg": "b888",
	"./sms-new.svg": "d072",
	"./sms-subject.svg": "1724",
	"./sms.svg": "694b",
	"./spu.svg": "9e41",
	"./star.svg": "708a",
	"./tab.svg": "8fb7",
	"./table copy.svg": "17e3",
	"./table.svg": "47f1",
	"./theme.svg": "e534",
	"./total-week.svg": "aff9",
	"./tree copy.svg": "9805",
	"./tree-table.svg": "e7c8",
	"./tree.svg": "93cd",
	"./user copy.svg": "294f",
	"./user.svg": "b3b5",
	"./verify.svg": "f9f0",
	"./warranty_auth.svg": "ee0a",
	"./warranty_car.svg": "4320",
	"./warranty_customer.svg": "fb51",
	"./warranty_product.svg": "12bc",
	"./warranty_user.svg": "2afd",
	"./wechat.svg": "80da",
	"./weichat_pay.svg": "c966",
	"./zip.svg": "8aa6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";